export default "__VITE_ASSET__9hMcegHp__"